module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderInfo) ? _c('div', {
    staticClass: "orderdetails"
  }, [(_vm.orderInfo.source == 'luckSunday' || _vm.showHappySunday) ? _c('div', {
    staticClass: "back-luck-sunday"
  }, [_vm._v("\n      幸福星期天品牌特卖 >\n      "), _c('wx-open-launch-weapp', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "top": "0",
      "left": "0"
    },
    attrs: {
      "username": "gh_3318973708df",
      "path": "happySunday/pages/index/index"
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n          <style>.btn {position: absolute;top:0;left:0;width:100%;height:100%;opacity:0}</style>\n          <button class=\"btn\"></button>\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('h2', {
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.orderStatusTitle) + " >")]), _vm._v(" "), (_vm.orderInfoVisible) ? _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "dialog-order br20"
  }, [(_vm.orderStatus != '') ? _c('ul', {
    staticClass: "main no-foot mydialog"
  }, _vm._l((_vm.orderInfo.flowList), function(item) {
    return _c('li', {
      staticClass: "order-list"
    }, [_c('div', {
      staticClass: "order-cards icon"
    }, [_c('div', {
      staticClass: "cards-first "
    }, [_c('div', {
      staticClass: "cards-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('div', {
      staticClass: "cards-sec"
    }, [_vm._v("\n                " + _vm._s(item.subTitle) + "\n                "), (item.mobile) ? _c('a', {
      staticClass: "shop-tel-icon",
      staticStyle: {
        "border-left": "none",
        "width": ".4rem",
        "padding-left": ".2rem",
        "margin-left": "0"
      },
      attrs: {
        "href": 'tel:' + item.mobile
      }
    }) : _vm._e()])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mybnt"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.orderInfoVisible = false
      }
    }
  }, [_vm._v("关 闭")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "orderProgress"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderStatusSubTitle))]), _vm._v(" "), (_vm.orderInfo.orderFuncStr) ? _c('div', {
    staticClass: "fs-24 mb20"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderFuncStr))]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.beGuaranteed === 1) ? _c('div', {
    staticClass: "fs-20 fw-bold flex-row-sc mb20",
    on: {
      "click": function($event) {
        return _vm.viewPunctual()
      }
    }
  }, [_c('img', {
    staticClass: "mr10",
    staticStyle: {
      "width": ".24rem"
    },
    attrs: {
      "src": require("../assets/images/icon-punctual-arrive.png")
    }
  }), _vm._v("\n        " + _vm._s(_vm.orderInfo.guaranteeTitle) + "\n        "), _c('div', {
    staticClass: "fs-20 fc-999 ml10 flex-row-sc"
  }, [_vm._v("\n          " + _vm._s(_vm.orderInfo.guaranteeStatusStr) + "\n          "), _c('img', {
    staticClass: "ml10",
    staticStyle: {
      "width": ".1rem"
    },
    attrs: {
      "src": require("../assets/images/arrow-right.png")
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "progress-contain"
  }, [(_vm.orderStatus == 1000) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.clickHandle(2)
      }
    }
  }, [_vm._v("立即支付")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 1000) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.cancelOrder(_vm.orderId)
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus == 2002 || _vm.orderStatus == 3001 || _vm.orderStatus == 9000) ? _c('a', {
    staticClass: " btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.moreOrder(_vm.orderId, _vm.orderInfo.supplier_id, _vm.orderInfo.supplier_name)
      }
    }
  }, [_vm._v("再来一单")]) : _vm._e(), _vm._v(" "), (_vm.orderStatus > 1000 && _vm.orderStatus < 3001) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding",
    on: {
      "click": function($event) {
        return _vm.clickHandle(3)
      }
    }
  }, [_vm._v("确认收货")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.reminderButton == 1) ? _c('a', {
    staticClass: " btn-ellipse border moreOrder-padding",
    on: {
      "click": function($event) {
        return _vm.reminderOrder(_vm.orderId)
      }
    }
  }, [_vm._v("催单")]) : _vm._e(), _vm._v(" "), ((_vm.orderInfo.refundStatus == 1 && !_vm.orderInfo.cancelLeftSeconds) && (_vm.orderStatus == 1001 || _vm.orderStatus == 2001 || _vm.orderStatus == 2002 || _vm.orderStatus == 3001)) ? _c('a', {
    staticClass: "btn-ellipse moreOrder-padding border",
    on: {
      "click": function($event) {
        return _vm.clickHandle(1)
      }
    }
  }, [_vm._v("申请售后\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canEstimated == 1) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.clickHandle(5)
      }
    }
  }, [_vm._v("评价")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.refundStatus == 3 && (_vm.orderStatus == 3001 || _vm.orderStatus == 2001 || _vm.orderStatus == 2002 || _vm.orderStatus == 1001)) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding",
    on: {
      "click": function($event) {
        return _vm.clickHandle(8)
      }
    }
  }, [_vm._v("退款进度")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.cancelLeftSeconds > 0 && (_vm.orderStatus == 1001 || _vm.orderStatus == 2001 || _vm.orderStatus == 2002 || _vm.orderStatus == 3001)) ? _c('a', {
    staticClass: "btn-ellipse border moreOrder-padding ",
    on: {
      "click": function($event) {
        return _vm.cancelAndRefundOrder(_vm.orderId)
      }
    }
  }, [_vm._v("取消订单")]) : _vm._e()])]), _vm._v(" "), (_vm.orderStatus != '') ? _c('div', {
    staticClass: "main no-foot"
  }, [(_vm.orderInfo && _vm.orderInfo.showShopRefund == 1) ? _c('div', {
    staticClass: "aftermarket-results br20"
  }, [_vm._v("\n        商家修改了您的退款商品，请点击:查看售后->退款进度 查看详情，如对商家处理结果不满，您可发起申诉申请平台介入。\n      ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.showShopRefund == 2) ? _c('div', {
    staticClass: "aftermarket-results br20"
  }, [_vm._v("\n        商家拒绝了该退款申请，请点击:查看售后->退款进度 查看详情，如对商家处理结果不满，您可发起申诉申请平台介入。\n      ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.showShopRefund == 3) ? _c('div', {
    staticClass: "aftermarket-results br20"
  }, [_vm._v("\n        商家同意了退款申请，退款金额将在2个工作日左右到账。\n      ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.pickUpCode && _vm.orderInfo.orderType == 3 && _vm.orderStatus != 3001) ? _c('div', {
    staticClass: "food-code br20"
  }, [_c('div', {
    staticStyle: {
      "font-size": ".28rem",
      "color": "#4A4A4A"
    }
  }, [_vm._v("堂食取餐码")]), _vm._v(" "), _c('div', {
    staticClass: "qr-code",
    on: {
      "click": function($event) {
        return _vm.toQrCode(_vm.orderInfo.orderShortNumQrCode)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".29rem",
      "height": ".29rem"
    },
    attrs: {
      "src": require("../assets/images/code-er.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fz-28",
    staticStyle: {
      "color": "#F2596C",
      "margin-left": ".15rem"
    }
  }, [_vm._v("二维码")]), _vm._v(" "), _c('span', {
    staticClass: "qr-line"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#F2596C",
      "margin-left": ".32rem"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.pickUpCode))])])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 1) ? _c('div', [_c('div', {
    staticClass: "self-take-addr br20"
  }, [_c('p', {
    staticStyle: {
      "font-size": "0.24rem",
      "color": "#787878"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean ? '自提柜地址' : '自提地点'))]), _vm._v(" "), _c('div', {
    staticClass: "clearflow"
  }, [_c('h3', {
    staticClass: "fl"
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.orderPickUpInfoBean ? _vm.orderInfo.orderPickUpInfoBean.deviceAddress : _vm.orderInfo.pickUpAddr))]), _vm._v(" "), (!_vm.orderInfo.orderPickUpInfoBean) ? _c('span', {
    staticClass: "check-map fr",
    on: {
      "click": _vm.toCheckMap
    }
  }, [_vm._v("查看")]) : _vm._e()])]), _vm._v(" "), (_vm.orderStatus != 3001) ? _c('div', {
    staticClass: "self-take-box br20"
  }, [_c('div', {
    staticClass: "self-take-code",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('span', {
    staticClass: "color-grey fz-28"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean ? '存餐员联系电话' : '商家联系电话'))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#F2596C"
    },
    attrs: {
      "href": 'tel:' + _vm.orderInfo.supplierTel
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean ? _vm.orderInfo.orderPickUpInfoBean.deliveryTel : _vm.orderInfo.supplierTel))])]), _vm._v(" "), (_vm.orderStatus > 1000 && _vm.orderStatus != 9000 && !_vm.orderInfo.orderPickUpInfoBean) ? _c('div', {
    staticClass: "self-take-code"
  }, [_c('span', {
    staticClass: "color-grey fz-28"
  }, [_vm._v("取货码")]), _vm._v(" "), _c('div', {
    staticClass: "qr-code",
    on: {
      "click": function($event) {
        return _vm.toQrCode(_vm.orderInfo.orderShortNumQrCode)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".29rem",
      "height": ".29rem"
    },
    attrs: {
      "src": require("../assets/images/code-er.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fz-28",
    staticStyle: {
      "color": "#F2596C",
      "margin-left": ".15rem"
    }
  }, [_vm._v("二维码")]), _vm._v(" "), _c('span', {
    staticClass: "qr-line"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.32rem",
      "color": "#F2596C",
      "margin-left": ".32rem"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.pickUpCode))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.buildingAddress && _vm.orderInfo.buildingAddress.length > 0) ? _c('div', {
    staticClass: "self-take-box br20"
  }, [_c('div', {
    staticClass: "self-take-code",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('span', {
    staticClass: "color-grey fz-28"
  }, [_vm._v("宿舍信息")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.buildingAddress))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean && _vm.orderInfo.orderPickUpInfoBean.takeType == 0) ? _c('div', {
    staticClass: "selfInfo br20"
  }, [(_vm.orderInfo.orderPickUpInfoBean.takeStatus == '0') ? _c('div', {
    staticClass: "selfCode"
  }, [_c('div', {
    staticClass: "selfDes"
  }, [_vm._v("自提柜取餐码\n            "), _c('span', {
    staticClass: "takeCode"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean.takeCode ? _vm.orderInfo.orderPickUpInfoBean.takeCode : '无'))])]), _vm._v(" "), _c('div', {
    staticClass: "selfInfo-wrap"
  }, [_c('span', {
    staticClass: "selfBtn",
    on: {
      "click": _vm.showSelfInfo
    }
  }, [_vm._v("自提柜信息")])])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == '2' || _vm.orderInfo.orderPickUpInfoBean.takeStatus == '3') ? _c('div', {
    staticClass: "selfSuc"
  }, [_vm._v("\n          " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.takeName) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean && _vm.orderInfo.orderPickUpInfoBean.takeType == 1) ? _c('div', {
    staticClass: "selfInfo1 br20"
  }, [_c('div', {
    staticClass: "fz-32"
  }, [_c('img', {
    staticClass: "dingwei",
    attrs: {
      "src": require("../assets/images/icon-dingwei@2x.png")
    }
  }), _vm._v("\n          " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cell-no"
  }, [(_vm.orderInfo.orderPickUpInfoBean.takeStatus == 0) ? _c('div', {
    staticClass: "status"
  }, [_vm._v("待取")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 2) ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background": "#7ED321",
      "color": "#fff"
    }
  }, [_vm._v("已取\n          ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 3) ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background": "#D51A2A",
      "color": "#fff"
    }
  }, [_vm._v("废餐\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "no"
  }, [_vm._v("\n            " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.cellNo) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fz-24",
    staticStyle: {
      "color": "#797979"
    }
  }, [_vm._v("箱号")])]), _vm._v(" "), _c('div', {
    staticClass: "fz-28"
  }, [_vm._v("存餐时间：" + _vm._s(_vm.orderInfo.orderPickUpInfoBean.saveTimeStr))]), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 2) ? _c('div', {
    staticClass: "fz-28"
  }, [_vm._v("\n          取餐时间：" + _vm._s(_vm.orderInfo.orderPickUpInfoBean.takeTimeStr) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 3) ? _c('div', {
    staticClass: "fz-28"
  }, [_vm._v("\n          废餐时间：" + _vm._s(_vm.orderInfo.orderPickUpInfoBean.lockTimeStr) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 0) ? _c('div', {
    staticClass: "btn-open",
    staticStyle: {
      "margin": ".14rem 0 .2rem 0"
    },
    on: {
      "click": _vm.openCabinet
    }
  }, [_vm._v("一键开柜\n        ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 2) ? _c('div', {
    staticClass: "btn-open disabled"
  }, [_vm._v("已取餐")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 3) ? _c('div', {
    staticClass: "btn-open disabled"
  }, [_vm._v("已废餐")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderPickUpInfoBean.takeStatus == 0) ? _c('div', {
    staticClass: "fc-grey-light"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.orderInfo.orderPickUpInfoBean.msgTemplate)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.orderInfo.order_status === 2001 || _vm.orderInfo.order_status === 2002 || _vm.orderInfo.order_status === 3001) && _vm.orderInfo.deliveryNickName) ? _c('div', {
    staticClass: "reward-box"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".6rem",
      "height": ".6rem",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.orderInfo.deliveryAvatar,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "delivery-name"
  }, [_vm._v(_vm._s(_vm.orderInfo.deliveryNickName))])]), _vm._v(" "), (_vm.orderInfo.canContactDelivery) ? _c('a', {
    staticClass: "order-tel1",
    staticStyle: {
      "width": "1.8rem"
    },
    attrs: {
      "href": 'tel:' + _vm.orderInfo.deliveryPhone
    }
  }, [_vm._v("联系西游侠")]) : _c('div', {
    staticClass: "delivery-btn",
    on: {
      "click": function($event) {
        return _vm.toReward(_vm.orderInfo.order_id)
      }
    }
  }, [_vm._v("打赏西游侠")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list order-list",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('ul', {
    staticClass: "br20"
  }, [_c('li', {
    staticClass: "title flexrow",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "flexrow",
    staticStyle: {
      "justify-content": "space-between",
      "align-items": "center",
      "margin-bottom": "0.15rem"
    }
  }, [_c('span', {
    staticClass: "shop-name ellipse",
    on: {
      "click": function($event) {
        return _vm.toGoodsList(_vm.orderInfo.supplier_id, _vm.orderInfo.supplier_name)
      }
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.supplier_name))]), _vm._v(" "), _c('span', {
    staticClass: "flexrow"
  }, [(_vm.managerInfo.mp) ? _c('a', {
    staticClass: "order-tel",
    attrs: {
      "href": 'tel:' + _vm.managerInfo.mp
    }
  }, [_vm._v("联系本校客服")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "order-tel1",
    attrs: {
      "href": 'tel:' + _vm.orderInfo.supplierTel
    }
  }, [_vm._v("联系商家")])])]), _vm._v(" "), _c('div', {
    staticClass: "order-id"
  }, [_vm._v("单号："), _c('span', {
    attrs: {
      "id": "codeNum"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.order_id))]), _c('span', {
    staticClass: "copy",
    on: {
      "click": function($event) {
        return _vm.copy()
      }
    }
  }, [_vm._v("复制")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "goods-list"
  }, [_vm._l((_vm.orderInfo.goods_list), function(item) {
    return _c('div', {
      staticClass: "clearflow goods-container"
    }, [_c('div', {
      staticClass: "goods-img fl",
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "fl flexcol",
      staticStyle: {
        "margin": "0",
        "width": "65%"
      }
    }, [_c('span', {
      staticClass: "goods-name",
      staticStyle: {
        "font-weight": "bold",
        "width": "100%"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.specification) ? _c('span', {
      staticClass: "goods-spec"
    }, [_vm._v(_vm._s(item.specification))]) : _vm._e(), _vm._v(" "), (item.attribute) ? _c('span', {
      staticClass: "goods-spec"
    }, [_vm._v(_vm._s(item.attribute))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flexcol",
      staticStyle: {
        "align-items": "flex-end"
      }
    }, [_c('div', {
      staticClass: "flexrow"
    }, [(item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined) ? _c('span', {
      staticClass: "pri ori_pri"
    }, [_vm._v("￥" + _vm._s(item.originalGdAmount))]) : _c('span', {
      staticClass: "pri ori_pri"
    }), _vm._v(" "), _c('span', {
      class: ['pri', {
        on: item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined
      }]
    }, [_vm._v("￥" + _vm._s(item.gdAmount))])]), _vm._v(" "), _c('span', {
      staticClass: "goods_num"
    }, [_vm._v("x" + _vm._s(item.buyNum))])])])
  }), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.gift_list && _vm.orderInfo.gift_list.length > 0) ? _c('div', {
    staticClass: "gift-info clearflow"
  }, [_c('div', {
    staticClass: "fl flexrow",
    staticStyle: {
      "width": "30%",
      "align-items": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.orderInfo.gift_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.gift_activity_name))])]), _vm._v(" "), (_vm.orderInfo.gift_list[0].name.length < 10) ? _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.orderInfo.gift_list[0].name) + "x" + _vm._s(_vm.orderInfo.gift_list[0].buyNum))]) : _c('span', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.orderInfo.gift_list[0].name.substring(0, 10)) + "...x" + _vm._s(_vm.orderInfo.gift_list[0].buyNum))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orderInfo.orderFeeList), function(item) {
    return _c('div', {
      staticStyle: {
        "margin-top": "0.26rem",
        "font-size": ".26rem"
      }
    }, [_c('span', {
      style: ({
        color: item.titleColor
      })
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "fr ml10",
      style: ({
        color: item.valueColor
      })
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), (item.originValue) ? _c('span', {
      staticClass: "fr",
      staticStyle: {
        "text-decoration": "line-through",
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(item.originValue))]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "goods-list foot"
  }, [_c('span', {
    staticClass: "fr"
  }, [_vm._v("总计 "), _c('span', {
    staticClass: "c-red",
    staticStyle: {
      "font-size": "0.36rem",
      "font-weight": "bold"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderInfo.real_pay))])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "order-info br20"
  }, [_c('li', [_c('div', {
    staticClass: "goods-list details"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderDesc))])]), _vm._v(" "), (_vm.orderInfo.orderType == 0) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("送达时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.delivery_time))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 1) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("自提时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.delivery_time))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 3) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("就餐时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.delivery_time))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.upstairsDeliveryStr) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.upstairsDeliveryStr))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 0) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("收货地址")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.consignee) + " " + _vm._s(_vm.orderInfo.consignee_tel)), _c('br'), _vm._v(_vm._s(_vm.orderInfo.address))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 1) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("自提电话")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.consignee_tel))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderType == 3) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("预留电话")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.consignee_tel))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.create_time))])]), _vm._v(" "), (_vm.orderInfo.comment) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("订单备注")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.comment))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.paywayStr) ? _c('div', {
    staticStyle: {
      "margin-top": "0.14rem"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orderInfo.paywayStr))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.singleItemCouponName) ? _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("    ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": ".18rem",
      "color": "#707070"
    }
  }, [_vm._v("优惠说明：本单参与" + _vm._s(_vm.orderInfo.singleItemCouponName) + "，共享受优惠" + _vm._s(_vm.orderInfo.singleItemAmount) + "元")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "order-info"
  }, _vm._l((_vm.orderInfo.text_info), function(text) {
    return _c('li', [_vm._v(_vm._s(text.txt)), _c('span', {
      staticClass: "fr"
    }, [_vm._v("￥" + _vm._s(text.val))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.serviceList) ? _c('div', {
    staticClass: "service mask",
    on: {
      "click": _vm.closeServiceList,
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "arrow-right"
  }, [(_vm.orderInfo.isFinishAfter24H == 0) ? _c('div', [(_vm.complaint == 3 || _vm.complaint == 2) ? _c('p', {
    on: {
      "click": function($event) {
        return _vm.clickHandle(9)
      }
    }
  }, [_vm._v("在线投诉")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.isFinishAfter24H == 1) ? _c('div', [(_vm.complaint == 3 || _vm.complaint == 2) ? _c('p', {
    on: {
      "click": function($event) {
        return _vm.clickHandle(11)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.tel
    }
  }, [_vm._v("在线投诉")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.complaint == 1) ? _c('p', {
    staticStyle: {
      "margin": "0"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandle(10)
      }
    }
  }, [_vm._v("查看投诉")]) : _vm._e()]), _vm._v(" "), (_vm.orderInfo.refundStatus != 2) ? _c('li', {
    staticClass: "arrow-right"
  }, [(_vm.orderInfo.refundStatus == 1) ? _c('p', {
    on: {
      "click": function($event) {
        return _vm.clickHandle(7)
      }
    }
  }, [_vm._v("申请退款")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.refundStatus == 3) ? _c('p', {
    on: {
      "click": function($event) {
        return _vm.clickHandle(8)
      }
    }
  }, [_vm._v("退款进度")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isShowRedPacket) ? _c('div', {
    staticClass: "redPacketAlert",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "redPacketBox"
  }, [_c('div', {
    staticClass: "redPacketClose",
    on: {
      "click": function($event) {
        _vm.isShowRedPacket = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0.3rem 0.5rem"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.redPacketInfo.show_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.redPacketInfo.show_content))]), _vm._v(" "), _c('div', {
    staticClass: "redPacket",
    style: ({
      backgroundImage: 'url(' + _vm.redPacketInfo.show_pic + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "redPacketBtn",
    on: {
      "click": function($event) {
        _vm.wxShareMask = true
      }
    }
  }, [_vm._v("发红包")])])]) : _vm._e(), _vm._v(" "), (_vm.orderStatus > 1000 && _vm.orderInfo.redPacket != undefined && _vm.orderInfo.redPacket != null) ? _c('div', {
    staticClass: "redPacketIcon",
    style: ({
      backgroundImage: 'url(' + _vm.orderInfo.redPacket.show_pic + ')'
    }),
    on: {
      "click": function($event) {
        _vm.wxShareMask = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.wxShareMask) ? _c('div', {
    staticClass: "wxShareTips",
    on: {
      "click": function($event) {
        _vm.wxShareMask = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "wxShareImg"
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowSelf) ? _c('div', {
    staticClass: "selfWrap",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        _vm.isShowSelf = false
      }
    }
  }, [_c('div', {
    staticClass: "self-mask"
  }, [_c('div', {
    staticClass: "self-top"
  }, [_vm._v("自提柜信息")]), _vm._v(" "), _c('div', {
    staticClass: "self-name",
    staticStyle: {
      "margin-bottom": ".32rem"
    }
  }, [_c('span', {
    staticClass: "name-left fl"
  }, [_vm._v("自提柜名称")]), _vm._v(" "), _c('span', {
    staticClass: "name-right fl"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceName))])]), _vm._v(" "), _c('div', {
    staticClass: "self-name",
    staticStyle: {
      "margin-bottom": ".32rem"
    }
  }, [_c('span', {
    staticClass: "name-left fl"
  }, [_vm._v("自提柜地址")]), _vm._v(" "), _c('span', {
    staticClass: "name-right fl"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "self-name"
  }, [_c('span', {
    staticClass: "name-left fl"
  }, [_vm._v("格子号")]), _vm._v(" "), _c('span', {
    staticClass: "name-right fl"
  }, [_vm._v(_vm._s(_vm.orderInfo.orderPickUpInfoBean.cellNo))])]), _vm._v(" "), _c('div', {
    staticClass: "closeBtn",
    on: {
      "click": function($event) {
        _vm.isShowSelf = false
      }
    }
  }, [_vm._v("确定")])])]) : _vm._e(), _vm._v(" "), (_vm.isShowCabinet) ? _c('div', {
    staticClass: "selfWrap"
  }, [_c('div', {
    staticClass: "self-mask",
    staticStyle: {
      "width": "6.4rem",
      "margin-left": "-3.2rem",
      "margin-top": "-3rem",
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "selfInfo1",
    staticStyle: {
      "padding": ".7rem .4rem .5rem .4rem",
      "margin-bottom": "0",
      "background-color": "transparent"
    }
  }, [_c('div', {
    staticClass: "fz-32"
  }, [_c('img', {
    staticClass: "dingwei",
    attrs: {
      "src": require("../assets/images/icon-dingwei@2x.png")
    }
  }), _vm._v("\n            " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.deviceName) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "cell-no",
    staticStyle: {
      "width": "1.8rem"
    }
  }, [_c('div', {
    staticClass: "no",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.orderPickUpInfoBean.cellNo) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "fz-32",
    staticStyle: {
      "color": "#797979"
    }
  }, [_vm._v("箱号")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": ".4rem 0"
    }
  }, [_vm._v("请确保在自提柜附近操作开柜，防止餐品丢失。")]), _vm._v(" "), (!_vm.isShowProgress) ? _c('div', {
    staticClass: "btn-open",
    staticStyle: {
      "height": ".84rem",
      "line-height": ".84rem",
      "margin-bottom": ".2rem"
    },
    on: {
      "click": _vm.sureCabinet
    }
  }, [_vm._v("确认开柜\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isShowProgress) ? _c('div', {
    staticClass: "progressbar"
  }, [_c('div', {
    staticClass: "fill"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-cancle",
    on: {
      "click": _vm.cancelCab
    }
  }, [_vm._v("取消开柜")])])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1173f5d1","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/OrderDetail.vue
// module id = 411
// module chunks = 7